export const COMENZAR_LOGIN = "COMENZAR_LOGIN";
export const EVENTO_LOGIN_EXITO = "EVENTO_LOGIN_EXITO";
export const EVENTO_LOGIN_ERROR = "EVENTO_LOGIN_ERROR";
export const EVENTO_LOGOUT_EXITO = "EVENTO_LOGOUT_EXITO";
export const EVENTO_LOGOUT_ERROR = "EVENTO_LOGOUT_ERROR";
export const RESET_ERROR_LOGIN = "RESET_ERROR_LOGIN";

export const COMENZAR_RECORDAR_CONTRASENA = "COMENZAR_RECORDAR_CONTRASENA";
export const EVENTO_RECORDAR_CONTRASENA_ERROR =
  "EVENTO_RECORDAR_CONTRASENA_ERROR";
export const EVENTO_RECORDAR_CONTRASENA_EXITO =
  "EVENTO_RECORDAR_CONTRASENA_EXITO";
export const RESET_ERROR_RECORDAR_CONTRASENA =
  "RESET_ERROR_RECORDAR_CONTRASENA";

export const COMENZAR_USUARIO_CONTRASENA = "COMENZAR_USUARIO_CONTRASENA";  
export const USUARIO_CONTRASENA_EXITO = "USUARIO_CONTRASENA_EXITO" ;
export const USUARIO_CONTRASENA_ERROR = "USUARIO_CONTRASENA_ERROR";
export const RESET_USUARIO_CONTRASENA = "RESET_USUARIO_CONTRASENA"; 

export const OBTENER_PEDIDOS = "OBTENER_PEDIDOS";
export const OBTENER_PEDIDOS_ERROR = "OBTENER_PEDIDOS_ERROR";
export const OBTENER_PEDIDOS_EXITO = "OBTENER_PEDIDOS_EXITO";

export const OBTENER_RUTAS = "OBTENER_RUTAS";
export const OBTENER_RUTAS_EXITO = "OBTENER_RUTAS_EXITO";
export const OBTENER_RUTAS_ERROR = "OBTENER_RUTAS_ERROR";

export const OBTENER_WSGSTATUS = "OBTENER_WSGSTATUS";
export const OBTENER_WSGSTATUS_EXITO = "OBTENER_WSGSTATUS_EXITO";
export const OBTENER_WSGSTATUS_ERROR = "OBTENER_WSGSTATUS_ERROR";

export const COMENZAR_EDICION_PEDIDORUTA = "COMENZAR_EDICION_PEDIDORUTA";
export const PEDIDORUTA_EDITADO_EXITO = "PEDIDORUTA_EDITADO_EXITO";
export const PEDIDORUTA_EDITADO_ERROR = "PEDIDORUTA_EDITADO_ERROR";
export const RESET_EDICION_PEDIDORUTA = "RESET_EDICION_PEDIDORUTA";

export const COMENZAR_EDICION_RUTA = "COMENZAR_EDICION_RUTA";
export const RUTA_EDITADO_EXITO = "RUTA_EDITADO_EXITO";
export const RUTA_EDITADO_ERROR = "RUTA_EDITADO_ERROR";
export const RESET_EDICION_RUTA = "RESET_EDICION_RUTA";